import { isString } from '@cutwise/utils';

import Storage, { KEY_DEADZONES_PENDING_TASKS, KEY_SPECTRUM_PENDING_TASKS } from '@/common/services/Storage';

const PENDING_GROUPS = [KEY_DEADZONES_PENDING_TASKS, KEY_SPECTRUM_PENDING_TASKS];

export class PendingTasksService {
  static pendingTasksByGroup() {
    return PENDING_GROUPS.reduce<Record<string, string[]>>((result, key) => {
      const tasks = Storage.getObject(key, Storage.STORAGE_LOCAL);

      if (isString(tasks)) {
        const tasksArray = tasks.split(',');

        if (tasksArray.length > 0) {
          result[key] = tasksArray;
        }
      }

      return result;
    }, {});
  }

  static hasPendingTasks() {
    return Object.keys(PendingTasksService.pendingTasksByGroup()).length > 0;
  }
}
